import Layout from "../layouts/layout";
import Add from "../sections/_shackClosing/Add";
import Table from "../sections/_shackClosing/Table";
import styles from "../styles/_screens/shackClosing.module.scss";

const ShackClosing = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <h1>Closing the Barracks</h1>

          <Add />
          <Table />
        </div>
      </div>
    </Layout>
  );
};

export default ShackClosing;
